import { clampSlugForKey, shortItemId } from './_uilm-key-internals';

/**
 * Build a UILM key for a field's label, help text, or placeholder.
 *
 * The slug head is normalized by `clampSlugForKey` so very long slugs
 * don't overflow the 100-char UILM limit when combined with the fixed
 * `_SCR_S{8HEX}_FLD_F{8HEX}_PLACEHOLDER` suffix (the longest one).
 *
 *   uilmKeyForField('nda', 'a3f2b1c8-...', 'b7d3e9f1-...', 'label')
 *   → 'NDA_SCR_SA3F2B1C8_FLD_FB7D3E9F1_LABEL'
 */
export type FieldKeyType = 'label' | 'help' | 'placeholder';

export function uilmKeyForField(
  templateSlug: string,
  screenItemId: string,
  fieldItemId: string,
  type: FieldKeyType,
): string {
  return [
    clampSlugForKey(templateSlug),
    'SCR',
    shortItemId(screenItemId, 'S'),
    'FLD',
    shortItemId(fieldItemId, 'F'),
    type.toUpperCase(),
  ].join('_');
}
